import * as React from "react";
import { getMantineSize, getMaxWidthClass, is90vwWidth, get90vwStyleOverride, MaxWidthType } from "../utils/styleUtils";
import { getModalClassNames, getHeaderClassNames } from "../utils/modalProps";

/**
 * Hook to manage ResponsiveModal styles and sizing
 * Generates all style-related values with proper memoization
 */
export function useResponsiveModalStyles(
  maxWidth: MaxWidthType = "2xl",
  className: string = "",
  hasHeaderContent: boolean = false
) {
  // Get the maxWidth class for the modal content
  const maxWidthClass = React.useMemo(() => {
    return getMaxWidthClass(maxWidth);
  }, [maxWidth]);

  // Map maxWidth to Mantine size
  const mantineSize = React.useMemo(() => {
    return getMantineSize(maxWidth);
  }, [maxWidth]);

  // Get CSS variable overrides for 90vw modal sizing
  const rootStyleOverride = React.useMemo(() => {
    return is90vwWidth(maxWidth) ? get90vwStyleOverride() : undefined;
  }, [maxWidth]);

  // Get classNames for modal content and header
  const classNames = React.useMemo(() => {
    return getModalClassNames(maxWidth, className);
  }, [maxWidth, className]);

  // Get header classNames
  const headerClassNames = React.useMemo(() => {
    return getHeaderClassNames(hasHeaderContent);
  }, [hasHeaderContent]);

  return {
    maxWidthClass,
    mantineSize,
    rootStyleOverride,
    classNames,
    headerClassNames,
    is90vw: is90vwWidth(maxWidth),
  };
}
